// Editorial motion should leave enough time to read the image, not just register movement.
// Keep interaction feedback (menus, buttons, pointer depth) out of this scale so the site stays responsive.
export const MOTION_TIMING = Object.freeze({
  castPoseStepMs: 1100,
  castPoseHoldMs: 2600,
  revealDelayScale: 1.35,
  homeFilmDurationMs: 78000,
  homeFilmStartDelayMs: 600,
  registrarStampToPoseMs: 340,
  registrarTierStepMs: 800,
  registrarLoopMs: 1400,
});
